<template>
  <div class="card-loader">
    <div class="relative divide-brand-sand border-t-2 border-brand-sand">
      <div class="px-10 pt-10 pb-8">
        <ContentLoader class="content-loader" width="540" height="80" :primaryColor="brandSand" :secondaryColor="brandLightSand">
          <rect x="0" y="0" width="540" height="21" rx="4" />
          <rect x="0" y="29" width="299" height="21" rx="4" />
          <rect x="0" y="58" width="267" height="21" rx="4" />
        </ContentLoader>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { ContentLoader } from 'vue-content-loader';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@/../tailwind.config';

const {
  theme: { colors },
} = resolveConfig(tailwindConfig);

export default Vue.extend({
  name: 'CardLoader',
  components: {
    ContentLoader,
  },
  data() {
    return {
      brandLightSand: colors['brand-light-sand'],
      brandSand: colors['brand-sand'],
    };
  },
});
</script>

<style lang="scss">
.card-loader {
  height: 168px;
  .content-loader {
    max-width: 540px;
  }
}
</style>
